import React from "react";
import "./visual-story.m.css";
import { altTagOfHeroImages, isExternalStory, isFacebookApp } from "../../../utils";
import { ResponsiveHeroImage } from "@quintype/components";
import { StoryHeaderCard } from "../../story-page-components/story-header-card";
import { breakpoint } from "../../../../utils/breakpoint";
import PropTypes from "prop-types";
import { SvgHandler } from "../../svg-handler/svg-handler";
import ampIcon from "../../../../assets/icons/amp-icon.svg";

export const VisualStory = ({ story = {}, config = {} }) => {
  const imageElement = breakpoint("tablet") ? (
    <ResponsiveHeroImage
      story={story}
      aspectRatio={[16, 9]}
      alt={altTagOfHeroImages(story)}
      defaultWidth={480}
      widths={[250, 480, 640]}
      sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 98%"
      imgParams={{ auto: ["format", "compress"], fit: "max" }}
    />
  ) : (
    <ResponsiveHeroImage
      story={story}
      aspectRatio={[8, 3]}
      alt={altTagOfHeroImages(story)}
      defaultWidth={480}
      widths={[250, 480, 640, 960, 1200]}
      sizes="(max-width: 500px) 98%"
      imgParams={{ auto: ["format", "compress"], fit: "max" }}
    />
  );

  const isFBApp = isFacebookApp();

  return (
    <article className="blank-story">
      {story["hero-image-s3-key"] ? (
        <figure className="blank-story-hero-image qt-responsive-image">{imageElement}</figure>
      ) : (
        <div className="blank-story-hero-image__fallback-placeholder" />
      )}
      <div className="blank-story--wrapper">
        <div className="blank-story--content" styleName="container">
          <StoryHeaderCard story={story} config={config} />
          <div styleName="cta">
            {/* Do not remove the below anchor tag, used to fix FB navigation issues */}
            <a
              href={`${isExternalStory(story)}`}
              rel={`${!isFBApp ? "noopener noreferrer" : ""}`}
              target={`${!isFBApp ? "_blank" : "_self"}`}
            >
              <div styleName="ampIcon">
                <SvgHandler xlinkHref={ampIcon} width="24px" height="24px" />
              </div>
              View story
            </a>
          </div>
        </div>
      </div>
    </article>
  );
};

VisualStory.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object
};
